/**
 * Format bytes to a human readable format
 * @param bytes - The number of bytes to format
 * @param decimals - The number of decimal places to show
 * @returns The formatted string
 */
export function formatBytes(bytes, decimals = 2) {
    if (bytes === 0)
        return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
/** Enough of the ending to recognise a file by: its extension and the characters just before it. */
const FILE_NAME_TAIL_LENGTH = 8;
/**
 * Splits a file name so a label can be shortened by the space it has rather than by a character count.
 *
 * Truncating in JavaScript cuts a name that would have fit; leaving it to CSS cuts nothing until the
 * row is genuinely too narrow. The split is what keeps the extension readable either way - the head
 * ellipsizes, the tail does not.
 */
export function getFileLabelParts(name, { size, tailLength = FILE_NAME_TAIL_LENGTH } = {}) {
    const extensionIndex = name.lastIndexOf('.');
    // a leading dot belongs to the name itself: ".gitignore" has no extension to keep
    const baseName = extensionIndex > 0 ? name.slice(0, extensionIndex) : name;
    const extension = extensionIndex > 0 ? name.slice(extensionIndex) : '';
    const keptFromBaseName = baseName.length > tailLength ? baseName.slice(-tailLength) : baseName;
    const head = baseName.slice(0, baseName.length - keptFromBaseName.length);
    const sizeSuffix = size == null ? '' : ` (${formatBytes(size, 0)})`;
    return { head, tail: `${keptFromBaseName}${extension}${sizeSuffix}` };
}
